import { render, staticRenderFns } from "./JourneyDay.vue?vue&type=template&id=39b90687&scoped=true"
import script from "./JourneyDay.vue?vue&type=script&lang=js"
export * from "./JourneyDay.vue?vue&type=script&lang=js"
import style0 from "./JourneyDay.vue?vue&type=style&index=0&id=39b90687&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b90687",
  null
  
)

export default component.exports